import { useEffect, useRef, useState } from "react";

export const useJobPolling = (
  checkJobStatus,
  interval = 2000,
  onComplete,
  onError,
) => {
  const [jobInfo, setJobInfo] = useState(null);
  const [isPolling, setIsPolling] = useState(false);
  const intervalRef = useRef(null);

  const stopPolling = () => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
    setIsPolling(false);
  };

  const startPolling = async (jobId) => {
    setIsPolling(true);

    const poll = async () => {
      try {
        const apiData = await checkJobStatus(jobId);
        const data = apiData?.data ?? apiData;

        if (data?.status === "completed" && data?.progress < 100) {
          data.progress = 100;
        }

        setJobInfo(data);

        if (data?.status === "failed") {
          stopPolling();
          onError?.(null, apiData);
          return false;
        }

        if (data?.status === "completed" || data?.progress >= 100) {
          if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
          }

          setTimeout(() => {
            setIsPolling(false);
            onComplete?.(data, apiData);
          }, 3000);
          return false;
        }

        return true;
      } catch (error) {
        console.error("Polling error:", error);
        stopPolling();
        onError?.(error);
        return false;
      }
    };

    const shouldContinue = await poll();
    if (shouldContinue) {
      intervalRef.current = setInterval(poll, interval);
    }
  };

  useEffect(() => () => stopPolling(), []);

  return { jobInfo, isPolling, startPolling, stopPolling };
};
